import React from "react";
import { Link } from "react-router-dom";

// CSS
import "../../css/sections/section-footer.css";

class SectionFooter extends React.PureComponent {
	render() {
		return (
			<Link to={this.props.href} className="section-footer">
				<span className="section-footer--title">{this.props.children}</span>
				<span className="icon-plus" />
			</Link>
		);
	}
}

export default SectionFooter;



// WEBPACK FOOTER //
// ./src/components/utils/SectionFooter.js